<script setup>
import AppIcon from '@/components/ui/AppIcon/AppIcon'

defineOptions({
  name: 'CheckinsFeedEmptyStateItem'
})
</script>

<template>
  <div class="cfes-EmptyState">
    <div class="cfes-EmptyState_Content">
      <AppIcon class="cfes-ContentHero" height="40" icon-name="no-checkins-feed-hero" width="55" />

      <div class="cfes-ContentMessage">
        <div class="cfes-ContentMessage_Title">{{ $t('checkins.feed.empty_state.title') }}</div>
        <div class="cfes-ContentMessage_Description">
          {{ $t('checkins.feed.empty_state.message') }}
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '~@/assets/styles/checkins-feed';

.cfes-EmptyState {
  padding-bottom: $checkins-feed-items-gap;
}

.cfes-EmptyState_Content {
  @extend %feed-item-common-styles;
  padding: $checkin-feed-item-py $checkin-feed-item-px;
}

.cfes-EmptyState_Content {
  display: flex;
  gap: 16px;
  align-items: center;
  line-height: 24px;
}

.cfes-ContentHero {
  flex-shrink: 0;
}

.cfes-ContentMessage_Title {
  font-size: $fs-14;
  font-weight: fw('semi-bold');
  color: $dark-1;
}

.cfes-ContentMessage_Description {
  font-size: $fs-12;
  color: $dark-2;
}
</style>
